import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./Context/LangContext";
import MainPage from "./Components/LandingPage/MainPage";
import Login from "./Components/Login/Login";
import SignUp from "./Components/Signup/SignUp";
import AboutUs from "./Components/AboutUs/AboutUs";
import Pricing from "./Components/Pricing/Pricing";
import Products from "./Components/OurProducts/OurProducts"
import Support from "./Components/Support/Support"
import PrivacyPoliciesMain from "./Components/PrivacyPoliciesMain/PrivacyPoliciesMain";
import MainFooter from "./Common/Footer";
import Header from "./Common/Header";
import MainCircular from "./Components/circularPage/MainCircular";
import Equity from "./Components/Trade And Invest/Equity/Equity";
import Derivatives from "./Components/Trade And Invest/Derivatives/Derivatives";
import BlogMarket from "./Components/Learn & Research/Blogs/BlogMarket";
import SubBorker from "./Components/Partner With us/Sub Broker/SubBroker";
import MarginCalculator from "./Components/Tools & Calculator/Margin Calculator/MarginCalculator"
import BrokerageCalculator from "./Components/Tools & Calculator/Brokerage Calculator/BrokerageCalculator"
// import Referral from "./Components/Partner With us/Referral Program";
import Faq from "./Components/Support/Faqs/FaqMainPage";
import FaqList from "./Components/Support/Faqs/FaqList";
import Platform from "./Components/Platforms/Platform";
import AboutBlog from "./Components/Learn & Research/Blogs/AboutBlog";
import Research from "./Components/Learn & Research/Stock Research/Research";
import FontControls from "./Common/FontControls";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <FontControls />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/aboutus" element={<><AboutUs /><MainFooter/></>} />
        <Route path="/pricing" element={<><Pricing /><MainFooter/></>} />
        <Route path="/products" element={<><Products /><MainFooter/></>} />

        <Route path="/Privacy_Policy" element={<><Header/><PrivacyPoliciesMain/><MainFooter/></>}/>
        <Route path="/refund_policy" element={<><Header/><PrivacyPoliciesMain/><MainFooter/></>}/>
        <Route path="/termsandconditions" element={<><Header/><PrivacyPoliciesMain/><MainFooter/></>}/>
        <Route path="/cdsl" element={<><Header/><PrivacyPoliciesMain/><MainFooter/></>}/>
        <Route path="/risk_disclosure" element={<><Header/><PrivacyPoliciesMain/><MainFooter/></>}/>
        <Route path="/bsda" element={<><Header/><PrivacyPoliciesMain/><MainFooter/></>}/>

        <Route path="/holiday_calendar" element={<><Header/><MainCircular/><MainFooter/></>}/>
        <Route path="/circular" element={<><Header/><MainCircular/><MainFooter/></>}/>
        <Route path="/issue_disclosures" element={<><Header/><MainCircular/><MainFooter/></>}/>


        <Route path="/trade-invest/equity" element={<><Header /><Equity /><MainFooter /></>} />
        <Route path="/trade-invest/derivatives" element={<><Header /><Derivatives /><MainFooter /></>} />

        <Route path="/tools-calculators/margin" element={<><Header /><MarginCalculator /><MainFooter /></>} />


        <Route path="/tools-calculators/brokerage" element={<><Header /><BrokerageCalculator /><MainFooter /></>} />

        <Route path="/learn-research/blog-news" element={<><Header /><BlogMarket /><MainFooter /></>} />
        <Route path="/learn-research/blogs/:blog_id" element={<><Header /><AboutBlog /><MainFooter /></>} />
          <Route path="/learn-research/market-research" element={<><Header /><Research /><MainFooter /></>} />

        <Route path="/platforms/apis" element={<><Header /> <Platform /> <MainFooter/></>}/>

        <Route path="/partner/autorized-person" element={<><Header /><SubBorker /><MainFooter /></>} />
        {/* <Route path="/partner/referral" element={<><Header /><Referral /></>} /> */}

        <Route path="/support/faqs" element={<><Header /><Faq /><MainFooter /></>} />
        <Route path="/support/faqs/:categoryName" element={<><Header /><FaqList /><MainFooter /></>} />
        <Route
          path="/support/faqs/:categoryName/:subCategory"
          element={<><Header /><FaqList /><MainFooter /></>}
        />
        <Route
          path="/support/faqs/:categoryName/:subCategory/:question"
          element={<><Header /><FaqList /><MainFooter /></>}
        />
{/* 
        <Route path="/learn-research/blogs/:blogId"
          element={<><Header /><AboutBlog /><MainFooter /></>} /> */}

        <Route path="/support/contact" element={<><Support /><MainFooter /></>} />

      </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
